import { defineFcm } from '../shared/factory';

export const FCM_MEMBERSHIP_BOTTOM_BANNER_ENABLED_FOR = defineFcm('membership_bottom_banner_enabled_for')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Petition Details page',
		description: 'This FC controls the visibility of membership bottom banner on petition details page',
		import: false,
	});
